import { type FormikProps } from "formik";
import { useTranslations } from "use-intl";

import { type THotelFormValues } from "@/app/lib/types/types";

import { Calendar } from "../Calendar";
import { Button } from "@mui/material";

function CheckInSelection<T extends Pick<THotelFormValues, "dates">>({
  formProps,
  onClose,
}: {
  formProps: FormikProps<T>;
  onClose: () => void;
}) {
  const t = useTranslations();

  return (
    <div className="flex h-full flex-col">
      <div className="h-full">
        <Calendar
          startField={{
            label: t("hotels.search.checkIn"),
            value: formProps.values.dates.checkIn,
            path: "dates.checkIn",
          }}
          endField={{
            label: t("hotels.search.checkOut"),
            value: formProps.values.dates.checkOut,
            path: "dates.checkOut",
          }}
          setFieldValue={formProps.setFieldValue}
          disabledDates={{
            before: new Date(),
          }}
          startMonth={new Date()}
        />
      </div>
      <Button fullWidth variant="contained" onClick={onClose}>
        {t("confirm")}
      </Button>
    </div>
  );
}

export default CheckInSelection;
